import React from "react";
import ProjectLanguages from "../projectLanguages/ProjectLanguages";
import "./ProjectCard.css";
import { Fade } from "react-reveal";

export default function ProjectCard({ repo: project, theme }) {
  function openRepoinNewTab(url) {
    if (url && url.trim() !== "") {
      var win = window.open(url, "_blank");
      win.focus();
    }
  }

  return (
    <div>
      <Fade bottom duration={2000} distance="40px">
        <div
          className="project-card"
          key={project.name}
          onClick={() => openRepoinNewTab(project.url)}
          style={{
            backgroundColor: theme.projectCard,
            color: theme.text,
            cursor:
              project.url && project.url.trim() !== "" ? "pointer" : "default",
          }}
        >
          <div className="repo-name-div">
            <p className="repo-name" style={{ color: theme.text }}>
              {project.name}
            </p>
          </div>
          <p className="repo-description" style={{ color: theme.text }}>
            {project.description}
          </p>
          <div className="repo-details">
            <ProjectLanguages logos={project.languages} />
          </div>
        </div>
      </Fade>
    </div>
  );
}
